import { CardReaderTechType } from 'src/app/modules/settings/services/http/api-settings.service'

export class AdriaCardReaderSettings {
  mainType: CardReaderTechType;
  useDualCardReader: boolean;
  antennaSwitchDelay: number;
  primaryAntennaOnlyForCommonAreaCards?: boolean

  constructor(mainType: CardReaderTechType, useDualCardReader: boolean,
    antennaSwitchDelay: number, primaryAntennaOnlyForCommonAreaCards: boolean) {
    this.mainType = mainType;
    this.useDualCardReader = useDualCardReader;
    this.antennaSwitchDelay = antennaSwitchDelay;
    if (primaryAntennaOnlyForCommonAreaCards === true || primaryAntennaOnlyForCommonAreaCards === false) {
      this.primaryAntennaOnlyForCommonAreaCards = primaryAntennaOnlyForCommonAreaCards;
    }
  }

  getPrimaryCardReaderTechTypeId(): CardReaderTechType {
    return this.mainType === CardReaderTechType.Mifare ? CardReaderTechType.Mifare:CardReaderTechType.Rfid;
  }

  /* getSecondaryCardReaderTechType(): CardReaderTechType {
    return this.mainType === CardReaderTechType.Mifare ? CardReaderTechType.Rfid:CardReaderTechType.Mifare;
  } */

  getSecondaryCardReaderTechTypeId(): CardReaderTechType | null {
    if (this.useDualCardReader) {
      return this.mainType === CardReaderTechType.Mifare ? CardReaderTechType.Rfid:CardReaderTechType.Mifare;
    } else {
      return null;
    }
  }

}
